import { ShieldCheck } from "lucide-react";
import { pilotTagLabel } from "../lib/pilots";
import { formatInstant } from "../lib/time";

// Small pieces shared by every card of the pilot screens (kept out of PilotPanel so the new cards can use them without a circular import).

// "AAAA-MM-JJ" -> "jj/mm/aaaa" without going through Date (a bare date has no timezone: no off-by-one day).
export function fmtDate(value) {
  if (!value) return "Non renseignée";
  const [y, m, d] = String(value).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

export const fmtInstant = (iso) => (iso ? formatInstant(iso) : "Non renseignée");

export function SectionTitle({ children, hint }) {
  return (
    <div className="flex items-baseline justify-between gap-3 mb-3">
      <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{children}</h4>
      {hint && <span className="text-2xs text-slate-400">{hint}</span>}
    </div>
  );
}

export function Row({ label, children, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 py-1.5 text-sm" data-testid={testid}>
      <span className="text-slate-500 shrink-0">{label}</span>
      <span className="text-slate-900 text-right min-w-0 break-words">{children}</span>
    </div>
  );
}

// "Pilote" marker for lists: teal while the pilot runs, grey once closed (same icon as the « Pilotes » navigation entry).
export function PilotTag({ status, testid }) {
  if (!status) return null;
  const running = status === "planned" || status === "active";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-medium ${running ? "bg-teal-50 text-teal-700 ring-1 ring-teal-200" : "bg-slate-100 text-slate-500"}`}
    >
      <ShieldCheck size={11} aria-hidden="true" />
      {pilotTagLabel(status)}
    </span>
  );
}
